import { Container } from "@mui/material";
import { VisualizedMenus } from "../components/VisualizedMenus";
import { Toolbar } from "../components/FooterToolbar";
import DiplomaSupplementTicket from "../components/DiplomaSupplementTicket";

const DSDetailPage = () => {
  return (
    <>
      <Container maxWidth="xl">
          <>
            <VisualizedMenus />
            <div id="pdf-content-2">
              <DiplomaSupplementTicket />
            </div>
          </>
        <Toolbar />
      </Container>
    </>
  );
};

export default DSDetailPage;